import { useTranslation, Trans } from "react-i18next";

export default function PrivacyPolicy() {
    const { t } = useTranslation();
    return (
        <>
        <div className=" bg-light">
        <div className="container">
            <p className=" pt-5"><h4>{t("privacyPolicy.title")}</h4></p>
            <p><Trans i18nKey="privacyPolicy.effective_date" /></p>
            <p><Trans i18nKey="privacyPolicy.intro" /></p>
            <h3>{t("privacyPolicy.h_collect")}</h3>
            <p>{t("privacyPolicy.collect_intro")}</p>
            <ul>
                <li><Trans i18nKey="privacyPolicy.collect_personal" /></li>
                <li><Trans i18nKey="privacyPolicy.collect_educational" /></li>
                <li><Trans i18nKey="privacyPolicy.collect_payment" /></li>
                <li><Trans i18nKey="privacyPolicy.collect_usage" /></li>
            </ul>
            <h3>{t("privacyPolicy.h_use")}</h3>
            <p>{t("privacyPolicy.use_intro")}</p>
            <ul>
                <li>{t("privacyPolicy.use_provide")}</li>
                <li>{t("privacyPolicy.use_personalize")}</li>
                <li>{t("privacyPolicy.use_process")}</li>
                <li>{t("privacyPolicy.use_communicate")}</li>
                <li>{t("privacyPolicy.use_improve")}</li>
            </ul>
            <h3>{t("privacyPolicy.h_sharing")}</h3>
            <p>{t("privacyPolicy.sharing_intro")}</p>
            <ul>
                <li><Trans i18nKey="privacyPolicy.sharing_providers" /></li>
                <li><Trans i18nKey="privacyPolicy.sharing_legal" /></li>
                <li><Trans i18nKey="privacyPolicy.sharing_business" /></li>
            </ul>
            <h3>{t("privacyPolicy.h_security")}</h3>
            <p>{t("privacyPolicy.security_text")}</p>
            <h3>{t("privacyPolicy.h_choices")}</h3>
            <p>{t("privacyPolicy.choices_intro")}</p>
            <ul>
                <li>{t("privacyPolicy.choices_access")}</li>
                <li>{t("privacyPolicy.choices_manage")}</li>
                <li>{t("privacyPolicy.choices_opt_out")}</li>
            </ul>
            <p><Trans i18nKey="privacyPolicy.contact_request" components={{ a: <a href="info@xller.com" />, strong: <strong /> }} /></p>
            <h3>{t("privacyPolicy.h_cookies")}</h3>
            <p>{t("privacyPolicy.cookies_text")}</p>
            <h3>{t("privacyPolicy.h_changes")}</h3>
            <p>{t("privacyPolicy.changes_text")}</p>
            <h3>{t("privacyPolicy.h_contact")}</h3>
            <p>{t("privacyPolicy.contact_intro")}</p>
            <p><strong>Xller</strong> {t("privacyPolicy.email")} <strong>info@xller.com</strong></p>
            </div>
            </div>
        </>
    )
}